const nowDate = new Date();
const curYear = nowDate.getFullYear();
const curMonth = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
    : nowDate.getMonth() + 1;
const curDay = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();

export function getCurDate(){
    return  curYear + "-" + curMonth + "-" + curDay;
}
export function getCurYear(){
    return curYear;
}
export function getCurYearAndMonth(){
    return  curYear + "-" + curMonth;
}

export function dateTimeToString(date,need){
    const year  = date.getFullYear();
    let month  = date.getMonth()+1;
    month = month > 9 ? month+"" : "0"+month;
    let day   = date.getDate();
    day = day > 9 ? day+"" : "0"+day;

    if(need) {
        let hour = date.getHours();
        hour = hour > 9 ? hour + "" : "0" + hour;
        let min = date.getMinutes();
        min = min > 9 ? min + "" : "0" + min;
        let second = date.getSeconds();
        second = second > 9 ? second + "" : "0" + second;
        return year+"-"+month+"-"+day+" "+hour+":"+min+":"+second;
    }else{
        return year+"-"+month+"-"+day;
    }

}
